import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { DECO_ICONS } from "@/components/holiday/useHoliday";
import { Falling } from "@/components/holiday/HolidaySkin";

const Garland = ({ theme }) => {
  const icons = DECO_ICONS[theme.deco] || DECO_ICONS.snow;
  return (
    <div className="absolute top-3 right-3 flex gap-2" aria-hidden="true" data-testid="overlay-holiday-garland">
      {[0, 1, 2].map((i) => {
        const Icon = icons[i % icons.length];
        return <span key={i} className="cx-hol-badge !static" style={{ color: i % 2 ? theme.color2 : theme.color, animationDelay: `${i * 0.6}s` }}><Icon className="w-3.5 h-3.5" /></span>;
      })}
    </div>
  );
};

export const OverlayHoliday = ({ overlayKey, preview }) => {
  const [theme, setTheme] = useState(null);
  useEffect(() => {
    if (preview) {
      fetch(`${API}/holiday`).then((r) => r.json()).then((d) => setTheme((d.themes || []).find((x) => x.id === preview) || null)).catch(() => {});
      return undefined;
    }
    const load = () => fetch(`${API}/overlay/${overlayKey}/feed`).then((r) => r.json()).then((d) => setTheme(d.holiday || null)).catch(() => {});
    load();
    const i = setInterval(load, 60000);
    return () => clearInterval(i);
  }, [overlayKey, preview]);
  if (!theme) return null;
  return (
    <div className="absolute inset-0" data-testid="overlay-holiday" data-theme={theme.id}>
      <Falling theme={theme} count={8} testid="overlay-holiday-fall" />
      <Garland theme={theme} />
    </div>
  );
};
